export default {
  debug: false,
  api: {
    version: '',
    // service: 'KYC',
    protocole: 'https',
    host: 'api.sandbox.dct.streammind.com',
    port: '443',
    // protocole: 'http',
    // host: '192.168.241.17',
    // port: '8160',
    // protocole: 'http',
    // host: '192.168.240.24',
    // port: '8160',
    address: function () {
      return this.protocole +
      '://' +
      this.host +
      (this.port !== '' ? ':' + this.port : '') +
      '/' +
      (this.version !== '' ? this.version + '/' : '')
    }
  },
  crypto: {
    secret: 'streammind'
  },
  language: 'en'
}